var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconCalTime = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 64 64"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-cal-time_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 161167",
  fill: "none",
  d: "M0 0h64v64H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31329",
  clipPath: "url(#icon-cal-time_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38653",
  d: "M54.857 32A22.857 22.857 0 1132 9.143 22.857 22.857 0 0154.857 32",
  fill: "#f9a23a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38654",
  d: "M49.033 46.307H15.451a.472.472 0 01-.472-.472V20.429a.472.472 0 01.472-.472h33.583a.472.472 0 01.472.472v25.406a.472.472 0 01-.472.472",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38655",
  d: "M49.078 46.997H15.407a1.12 1.12 0 01-1.119-1.119V20.379a1.12 1.12 0 011.119-1.119h33.67a1.12 1.12 0 011.123 1.119v25.5a1.12 1.12 0 01-1.119 1.119M15.67 45.615h33.144V20.647H15.67z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38656",
  d: "M22.22 31.17h-2.073a.424.424 0 01-.424-.424v-2.073a.424.424 0 01.424-.424h2.073a.424.424 0 01.424.424v2.073a.424.424 0 01-.424.424",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38657",
  d: "M22.259 31.631h-2.152a.846.846 0 01-.846-.845v-2.152a.847.847 0 01.846-.846h2.152a.847.847 0 01.845.846v2.152a.846.846 0 01-.845.845m-2.076-.921h2v-2h-2z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38658",
  d: "M27.749 31.17h-2.073a.424.424 0 01-.424-.424v-2.073a.424.424 0 01.424-.424h2.073a.424.424 0 01.424.424v2.073a.424.424 0 01-.424.424",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38659",
  d: "M27.789 31.631h-2.152a.846.846 0 01-.846-.845v-2.152a.847.847 0 01.846-.846h2.152a.847.847 0 01.845.846v2.152a.846.846 0 01-.845.845m-2.076-.921h2v-2h-2z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38660",
  d: "M33.278 31.17h-2.073a.424.424 0 01-.424-.424v-2.073a.424.424 0 01.424-.424h2.073a.424.424 0 01.424.424v2.073a.424.424 0 01-.424.424",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38661",
  d: "M33.318 31.631h-2.152a.847.847 0 01-.846-.845v-2.152a.847.847 0 01.846-.846h2.152a.847.847 0 01.846.846v2.152a.846.846 0 01-.846.845m-2.079-.922h2v-2h-2z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38662",
  d: "M38.808 31.17h-2.073a.424.424 0 01-.424-.424v-2.073a.424.424 0 01.424-.424h2.073a.424.424 0 01.424.424v2.073a.424.424 0 01-.424.424",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38663",
  d: "M38.847 31.631h-2.152a.847.847 0 01-.846-.845v-2.152a.847.847 0 01.846-.846h2.152a.847.847 0 01.846.846v2.152a.847.847 0 01-.846.845m-2.076-.921h2v-2h-2z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38664",
  d: "M44.337 31.17h-2.073a.424.424 0 01-.424-.424v-2.073a.424.424 0 01.424-.424h2.073a.424.424 0 01.424.424v2.073a.424.424 0 01-.424.424",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38665",
  d: "M44.376 31.631h-2.152a.846.846 0 01-.845-.845v-2.152a.847.847 0 01.845-.846h2.152a.847.847 0 01.846.846v2.152a.846.846 0 01-.846.845M42.3 30.71h2v-2h-2z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38666",
  d: "M22.22 36.837h-2.073a.424.424 0 01-.424-.424V34.34a.424.424 0 01.424-.424h2.073a.424.424 0 01.424.424v2.073a.424.424 0 01-.424.424",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38667",
  d: "M22.259 37.298h-2.152a.846.846 0 01-.846-.846v-2.151a.846.846 0 01.846-.846h2.152a.846.846 0 01.845.846v2.151a.846.846 0 01-.845.846m-2.076-.922h2v-2h-2z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38668",
  d: "M27.749 36.837h-2.073a.424.424 0 01-.424-.424V34.34a.424.424 0 01.424-.424h2.073a.424.424 0 01.424.424v2.073a.424.424 0 01-.424.424",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38669",
  d: "M27.789 37.298h-2.152a.846.846 0 01-.846-.846v-2.151a.846.846 0 01.846-.846h2.152a.846.846 0 01.845.846v2.151a.846.846 0 01-.845.846m-2.076-.922h2v-2h-2z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38670",
  d: "M33.278 36.837h-2.073a.424.424 0 01-.424-.424V34.34a.424.424 0 01.424-.424h2.073a.424.424 0 01.424.424v2.073a.424.424 0 01-.424.424",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38671",
  d: "M33.318 37.298h-2.152a.847.847 0 01-.846-.846v-2.151a.847.847 0 01.846-.846h2.152a.847.847 0 01.846.846v2.151a.847.847 0 01-.846.846m-2.079-.922h2v-2h-2z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38672",
  d: "M38.808 36.837h-2.073a.424.424 0 01-.424-.424V34.34a.424.424 0 01.424-.424h2.073a.424.424 0 01.424.424v2.073a.424.424 0 01-.424.424",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38673",
  d: "M38.847 37.298h-2.152a.847.847 0 01-.846-.846v-2.151a.847.847 0 01.846-.846h2.152a.847.847 0 01.846.846v2.151a.847.847 0 01-.846.846m-2.076-.922h2v-2h-2z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38674",
  d: "M44.337 36.837h-2.073a.424.424 0 01-.424-.424V34.34a.424.424 0 01.424-.424h2.073a.424.424 0 01.424.424v2.073a.424.424 0 01-.424.424",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38675",
  d: "M44.376 37.298h-2.152a.846.846 0 01-.845-.846v-2.151a.846.846 0 01.845-.846h2.152a.847.847 0 01.846.846v2.151a.847.847 0 01-.846.846m-2.076-.922h2v-2h-2z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38676",
  d: "M22.22 42.5h-2.073a.424.424 0 01-.424-.424v-2.073a.424.424 0 01.424-.424h2.073a.424.424 0 01.424.424v2.073a.424.424 0 01-.424.424",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38677",
  d: "M22.259 42.96h-2.152a.847.847 0 01-.846-.846v-2.152a.846.846 0 01.846-.845h2.152a.846.846 0 01.845.845v2.152a.847.847 0 01-.845.846m-2.076-.922h2v-2h-2z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38678",
  d: "M27.749 42.5h-2.073a.424.424 0 01-.424-.424v-2.073a.424.424 0 01.424-.424h2.073a.424.424 0 01.424.424v2.073a.424.424 0 01-.424.424",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38679",
  d: "M27.789 42.96h-2.152a.847.847 0 01-.846-.846v-2.152a.846.846 0 01.846-.845h2.152a.846.846 0 01.845.845v2.152a.847.847 0 01-.845.846m-2.076-.922h2v-2h-2z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38680",
  d: "M33.278 42.5h-2.073a.424.424 0 01-.424-.424v-2.073a.424.424 0 01.424-.424h2.073a.424.424 0 01.424.424v2.073a.424.424 0 01-.424.424",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38681",
  d: "M33.318 42.96h-2.152a.847.847 0 01-.846-.846v-2.152a.847.847 0 01.846-.845h2.152a.846.846 0 01.846.845v2.152a.847.847 0 01-.846.846m-2.079-.918h2v-2h-2z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38682",
  d: "M38.808 42.5h-2.073a.424.424 0 01-.424-.424v-2.073a.424.424 0 01.424-.424h2.073a.424.424 0 01.424.424v2.073a.424.424 0 01-.424.424",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38683",
  d: "M38.847 42.96h-2.152a.847.847 0 01-.846-.846v-2.152a.847.847 0 01.846-.845h2.152a.847.847 0 01.846.845v2.152a.847.847 0 01-.846.846m-2.076-.922h2v-2h-2z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38684",
  d: "M44.567 42.5h-2.533a.194.194 0 01-.194-.194v-2.533a.194.194 0 01.194-.194h2.533a.194.194 0 01.194.194v2.533a.194.194 0 01-.194.194",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38685",
  d: "M44.585 43.191h-2.572a.868.868 0 01-.867-.867v-2.569a.868.868 0 01.867-.867h2.569a.868.868 0 01.867.867v2.569a.868.868 0 01-.867.867m-2.054-1.382h1.539V40.27h-1.539z",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Line 1445",
  fill: "#fff",
  d: "M19.511 25.159h25.172"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38686",
  d: "M44.683 25.849H19.511a.691.691 0 110-1.382h25.172a.691.691 0 010 1.382",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38687",
  d: "M46.765 52.075h-2.15a7.189 7.189 0 01-7.189-7.189v-2.15a7.189 7.189 0 017.189-7.189h2.15a7.189 7.189 0 017.189 7.189v2.15a7.189 7.189 0 01-7.189 7.189",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38688",
  d: "M45.691 52.765a8.955 8.955 0 118.955-8.955 8.966 8.966 0 01-8.955 8.955m0-16.529a7.573 7.573 0 100 15.146 7.573 7.573 0 000-15.146",
  fill: "#29398c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38689",
  d: "M49.997 45.01h-4.7v-5.528",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38690",
  d: "M49.997 45.701h-4.7a.691.691 0 01-.691-.691v-5.529a.691.691 0 111.382 0v4.837h4.007a.691.691 0 110 1.382",
  fill: "#29398c"
}))));
export default __webpack_public_path__ + "static/icon-cal-time.5901a7ad86cc275dab5f0e0526a52fe3.svg";
export { SvgIconCalTime as ReactComponent };